

import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { fetchBlogByTopic, fetchBlogImgById ,fetchBlogs} from "../../redux/actions/action";
import { useEffect, useState } from "react";

import Header from "../Header";
import Footer from "../Footer";
import { uploadBlogImage } from "../../redux/actions/action";
import AuthorInfo from "./AuthorInfo";


const ReadMore = () => {

  const [currentPage,setCurrentPage] = useState(0);
 

  const maxPages = 5;
  const blogsPerPage = 1;

  const { topicName} = useParams();
  console.log("url params:",topicName)
  const decodedTopic = decodeURIComponent(topicName); // Decode it back

  console.log("ReadMore component mounted with topic:", topicName);
  // const blogs = useSelector((state) => state.uploadBlog.newBlog) ;
  // replace old blogs selector
const blogs = useSelector(
  (state) => state.uploadBlog.latestBlogsByTopic[decodedTopic] || []
);

  
  const blogImages = useSelector((state) => state.blogReducer.blogImage);//blogreducer is what we defined in rootreducer 

  

  if (!topicName) {
    console.error("❌ topicName is undefined! useEffect won't run.");
} else {
    console.log("✅ topicName exists:", topicName);
}

  const dispatch = useDispatch();
  console.log("🔹 Dispatch function:", dispatch);

  
useEffect(() => {
  console.log("🔹 useEffect triggered! topic:", topicName);
  console.log("🔍 Full ReadMore component re-rendering...");  // <-- Check if ReadMore re-renders


  if(topicName){
    console.log("Dispatching fetchBlogByTopic...");

  dispatch(fetchBlogByTopic(topicName)); // Fetch only the selected blog
  
}
else{
  console.warn("⚠️ Topic is missing, skipping dispatch.");

}
},[dispatch,topicName]);


  console.log("Blog Images from Redux:", blogImages);
 
  console.log("Blogs:", blogs); 
 
const blog = blogs[currentPage]||null;

useEffect(() => {
  const blog = blogs[currentPage];
  if (blog && blog.id) {
    dispatch(fetchBlogImgById(blog.id));
  }
}, [dispatch, blog]);

const totalPages = Math.min(Math.ceil(blogs.length/blogsPerPage),maxPages)//limit pages to 5 even if more blogs exist

const authInfo = blogImages[blog?.id] || null

  console.log("Calling fetchBlogByTopic ");

  console.log("Decoded Topic:", decodedTopic);
    
console.log("🔍 Looking for topic:", topicName);

console.log("Blog :", blog);
console.log("authInfo received for blog ID:", blog?.id, authInfo);


return (
  <div className="relative bg-gray min-h-screen w-full overflow-hidden">
          <div className="absolute flex mx-auto top-0 right-0 left-0 h-[80px] overflow-hidden ">
              <Header />
          </div>
         
   <div className="relative mt-40 mb-10 flex justify-center w-full px-4">
    
    <img src="/Rectangle 3.svg" alt="blog image" 
    className="w-[400px] h-[400px] border rounded-xl md:w-[700px] md:h-[400px] object-cover"/>
 </div> 

  
  <div className=" text-lg text-white bg-color  rounded-xl mb-0 py-1">
  

       <h1 className="text-2xl font-bold text-white m-2" >{decodedTopic}</h1> 
   
    { blog ? (
   

  <div className="flex flex-col  w-full bg-white text-black rounded-b-xl relative px-4 pb-4 ">

  <div className="min-h-[300px] w-full">

  <pre className="whitespace-pre-wrap font-poppins text-base font-medium text-gray-900">
    {blog.description || "No description available"}
  </pre>
  </div> 

  {/* author section */}

  <div className="mt-8 flex flex-col items-start m-5">
    {authInfo && <AuthorInfo authInfo={authInfo}/>}
    {/* {authInfo ? (
   <AuthorInfo authInfo={authInfo} /> 
  ) : (
    <p className="text-gray-500">Loading author info...</p>
  ) } */}
</div>

  {/*author ends */}
<div className="w-full mt-10 mb-16 flex justify-center items-center gap-4">

<button
  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
  disabled={currentPage === 0}
  className={`px-4 py-2 border rounded-md text-xl ${
    currentPage === 0 ? "opacity-50 cursor-not-allowed" : ""
  }`}
>

← 
</button>
<div className="bg-black p-2 text-white"> 
          Page{' '}
          <strong>
            {currentPage + 1} of {blogs.length}
            {/* {currentPage + 1} of {totalPages} */}
          </strong>
        </div>

<button
    onClick={() => setCurrentPage((prev) => prev + 1)}
    disabled={currentPage >= totalPages - 1}
    className={` px-4 py-2 border rounded-md text-xl ${
      currentPage >= totalPages - 1 ? "opacity-50 cursor-not-allowed" : ""
    }`}
  >
    →
  </button>
</div>

</div>
  
  ): <p>Fetching description...</p>}
  

</div>

<div className="mt-10">
<Footer/>
</div>
</div>
);
};


  




export default ReadMore;
